export default "__VITE_ASSET__4OQbxlKM__"